import React, { useEffect, useState } from 'react'
import { Button, Card, Col, Row, Table } from 'react-bootstrap'
import { useSearchParams } from 'react-router-dom'
import { useGetClassQuery } from '../../store/api/class/class.api'
import { IGetClassesData } from '../../store/api/class/model'
import Pagination from '../../ui/Pagination/Pagination'
import SearchFilters from '../../ui/filter/SearchFilters'
import { searchParamsData } from '../../utils/searchParamsData'
import Loading from '../Loading/Loading'
import ClassCreate from './ClassCreate/ClassCreate'
import ClassTable from './ClassTable/ClassTable'
import { DefaultParams, PAGESIZE } from '../../utils/constants'
import { useTranslation } from 'react-i18next'
import FilterBySchool from '../../ui/FilterBySchool/FilterBySchool'
import FilterByClass from '../../ui/FilterByClass/FilterByClass'

const Class = (): JSX.Element => {
  const { t: tGeneral } = useTranslation('general')
  const formRef = React.createRef<HTMLFormElement>()
  const [isOpenCreateModal, setOpenCreateModal] = useState<boolean>(false)
  const [editClass, setEditClass] = useState<IGetClassesData>()
  const [searchParams, setSearchParams] = useSearchParams()
  const {
    isLoading,
    data: classes,
    refetch
  } = useGetClassQuery(searchParamsData(searchParams, { ...DefaultParams }))
  useEffect(() => {
    if (!isOpenCreateModal) {
      refetch()
    }
  }, [isOpenCreateModal])

  useEffect(() => {
    refetch()
  }, [searchParams])

  const clearParams = (): void => {
    const newParams = new URLSearchParams()
    newParams.set('page', '1')
    if (formRef.current) {
      const keywordInput = formRef.current.querySelector<HTMLInputElement>('input[name="keyword"]')
      if (keywordInput) {
        keywordInput.value = ''
      }
    }
    setSearchParams(newParams)
  }

  return (
    <div>
      {isLoading && <Loading />}
      <Row className='mt-5 mb-5'>
        <form ref={formRef} className='w-100 d-flex p-0'>
          <FilterBySchool setQuery={setSearchParams} query={searchParams} />
          <FilterByClass setQuery={setSearchParams} query={searchParams} />
          <SearchFilters
            setQuery={setSearchParams}
            query={searchParams}
            placeholder='filterByClassName'
          />
          <Col md={6} xl={6}>
            <Button onClick={() => clearParams()}>{tGeneral('reset')}</Button>
          </Col>
        </form>
      </Row>
      <Row className=' row-sm'>
        <Col lg={12}>
          <Card className='custom-card'>
            <Card.Header>
              <Col xs={6} md={11}>
                <h3 className='card-title mb-1'>{tGeneral('classes')} </h3>
              </Col>
              <Col>
                <Button
                  onClick={() => {
                    setOpenCreateModal(true)
                    setEditClass(null)
                  }}
                >
                  {tGeneral('createClasses')}
                </Button>
              </Col>
            </Card.Header>
            <Card.Body>
              <div className='table-responsive'>
                <Table className='table table-bordered text-nowrap text-md-nowrap mg-b-0'>
                  <thead>
                    <tr className='text-center'>
                      <th>{tGeneral('id')}</th>
                      <th>{tGeneral('name')}</th>
                      <th>{tGeneral('description')}</th>
                      <th>{tGeneral('school')}</th>
                      <th>{tGeneral('section')}</th>
                      <th>{tGeneral('action')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {classes?.data.map(clas => (
                      <ClassTable
                        key={clas.id}
                        clas={clas}
                        refetch={refetch}
                        setOpenCreateModal={setOpenCreateModal}
                        setEditClass={setEditClass}
                      />
                    ))}
                  </tbody>
                </Table>
              </div>
            </Card.Body>
            <Pagination
              setQuery={setSearchParams}
              numPages={Math.ceil(classes?.count / PAGESIZE)}
              query={searchParams}
            />
          </Card>
        </Col>
      </Row>
      {isOpenCreateModal && (
        <ClassCreate onClose={() => setOpenCreateModal(false)} editClass={editClass} />
      )}
    </div>
  )
}

export default Class
